module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/96ae033a1d0502aa4a8471884748f619.gif";